const PENDING_TOAST_KEY = '__nl_pending_toast__';
export const MEMBERSHIP_PAYMENT_TOAST_EVENT = '__nl_toast__';

/** Remove legacy pending toast (was replayed on every refresh). */
export const clearStaleMembershipPaymentToast = () => {
	try {
		sessionStorage.removeItem(PENDING_TOAST_KEY);
	} catch (_e) {
	}
};

/** Show membership purchase/top-up success once, in the current session (no refresh replay). */
export const showMembershipPaymentSuccessToast = (message, options = {}) => {
	const normalizedMessage = message != null ? String(message).trim() : '';
	if (!normalizedMessage) return;

	try {
		window.dispatchEvent(
			new CustomEvent(MEMBERSHIP_PAYMENT_TOAST_EVENT, {
				detail: {
					type: 'success',
					message: normalizedMessage,
					options: options && typeof options === 'object' && !Array.isArray(options) ? options : {},
				},
			})
		);
	} catch (_e) {
	}
};
